import { useEffect, useState } from 'react'
import { getRemSize } from '../utils/getRemSize'

const useRemToPx = (): number => {
  const [px, setPx] = useState(0)

  const handler = (): void => {
    setPx(getRemSize())
  }

  useEffect(() => {
    handler()
    window.addEventListener('resize', handler)

    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [])

  return px
}

export { useRemToPx }
